<template>
  <custom-callout
    :has-toggle="true"
    class="mt-2"
    :border-color="getStatusColor(value.status)"
  >
    <div class="row mt-2 test">
      <div class="col-md-12 pt-3">
        <div class="row">
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Título:
            </div>
            <p class="info-text">
              {{ value.title }}
            </p>
          </div>
          <div class="col-md-4 col-6">
            <div class="info-text-title">
              Materia:
            </div>
            <p class="info-text">
              {{ value.subject }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <div class="info-text-title">
              Grado:
            </div>
            <p class="info-text">
              {{ value.grade }}
            </p>
          </div>
          <div class="col-md-2 col-6">
            <action-button
              :text="selectBtnText"
              i="far fa-check"
              variant="outline-success btn-transparent"
              @click="selectBook"
            />
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import { assignBookToStudent } from '@/modules/books-requests/api';
import store from '@/store/index';
import mixWait from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import { Colors } from '@/components/common';

export default {
  name: 'BookRequestSearchResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  computed: {
    selectBtnText() {
      let text = store.getters.getIsMobileDensity ? '' : 'Seleccionar';
      return text;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    getStatusColor() {
      return (status) => {
        switch (status) {
          case 'Pendiente de Determinación':
            return Colors.YELLOW;
          case 'Pendiente de Compra':
            return Colors.YELLOW;
          case 'Pendiente de Entrega de Centro':
            return Colors.PINK;
          case 'Pendiente de Entrega de Escuela':
            return Colors.PINK;
          case 'Entregado':
            return Colors.GREEN;
          default:
            return Colors.YELLOW;
        }
      };
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    academicYearId: {
      type: Number,
      required: true,
    },
  },
  mixins: [mixWait, alert],
  methods: {
    selectBook() {
      assignBookToStudent({
        academicYearId: this.academicYearId,
        bookId: this.value.bookId,
        studentSieId: Number(store.getters.SelectedStudent.studentId),
      })
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'El libro ha sido selecionado exitosamente.',
              'success'
            );
            this.$parent.onSearch({ fromSelectedBooks: true });
            this.$parent.addToSelectedBooks(this.value);
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>

<style scoped>
.btn-transparent {
  background-color: transparent !important;
}
.outline-success:hover {
  color: #fff;
  background-color: #2db782 !important;
}
.mrc {
  margin-left: 30px;
}
.info-text {
  color: #11291b !important;
}
.info-text-title {
  color: #727272 !important;
  font-size: 14px !important;
  font-weight: normal;
}
.orange-icon {
  color: #ff7058;
}

@media only screen and (max-width: 375px) {
  .btn-transparent >>> .fa-check {
    margin-right: 0px !important;
  }

  .info-text-title {
    color: #727272 !important;
    font-size: 12px !important;
    font-weight: normal;
  }
  .info-text {
    color: #11291b !important;
    font-weight: normal;
    font-size: 12px;
  }
}
</style>
